import React from "react";
import { router } from "@inertiajs/react";
import { SeletorDoGrupo } from "./SeletorDoGrupo";

interface Unidade {
    id: number;
    nome: string;
}

interface UnidadeSeletorProps {
    unidades: Unidade[];
    unidadeSelecionadaId?: number | null;
    /** `/m/{slug}/unidades` (a seguir ao `base_path`): escolher é `…/{id}/escolher`. */
    caminho: string;
    /** O nome de uma unidade («Lavandaria»), para os leitores de ecrã e o texto da lista. */
    rotulo: string;
    icone?: string;
    onUnidadeChange?: (unidade: Unidade, menu: any[]) => void;
}

/** O endereço da página aberta (o servidor diz qual é a mesma página na outra unidade). */
function paginaAberta(): string {
    return encodeURIComponent(window.location.pathname + window.location.search);
}

/**
 * A unidade de um módulo por unidade (plano 3.20) no topo do grupo do menu, como o hotel na
 * «Gestão Hoteleira». A unidade vai no endereço (`/m/lavandaria/maculusso/…`): escolher outra lembra-a
 * (o servidor), troca os endereços do menu e abre **a mesma página na outra unidade** — o servidor
 * devolve-a (`url`), o ecrã não monta o slug. A ficha de um registo volta à lista da entidade; uma
 * página que não é do módulo fica onde está. Com uma unidade só não aparece.
 */
export default function UnidadeSeletor({ unidades, unidadeSelecionadaId, caminho, rotulo, icone, onUnidadeChange }: UnidadeSeletorProps) {
    const minusculo = rotulo.toLocaleLowerCase("pt");

    return (
        <SeletorDoGrupo
            itens={unidades}
            selecionadoId={unidadeSelecionadaId}
            caminhoMenu={(id) => `${caminho}/${id}/escolher?de=${paginaAberta()}`}
            icone={icone || "mdi:domain"}
            rotulo={rotulo}
            placeholder={`Escolher ${minusculo}`}
            nadaEncontrado="Nada encontrado"
            textoErro={`Não foi possível mudar de ${minusculo}. Tenta de novo.`}
            onTrocar={(unidade, menu, resposta) => {
                onUnidadeChange?.(unidade, menu);
                if (typeof resposta?.url === "string" && resposta.url) {
                    router.visit(resposta.url, { preserveScroll: !resposta.para_a_lista });
                }
            }}
        />
    );
}
